<template>
  <a @click="sortby">
    <slot />
    {{ ' ' }}
    <span v-if="modelValue == field && !reverse">▾</span>
    <span v-if="modelValue == field && reverse">▴</span>
  </a>
</template>

<script lang="ts" setup>
const props = defineProps<{
  modelValue: string;
  field: string;
  reverse: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'update:reverse', event: boolean): void
}>();

function sortby() {
  if (props.modelValue === props.field) {
    emit('update:reverse', !props.reverse);
  } else {
    emit('update:modelValue', props.field);
    if (props.reverse) {
      emit('update:reverse', false);
    }
  }
}
</script>
